// API Configuration for Dark Matter Solutions
const API_CONFIG = {
  // Production API URL (Domain-based with HTTPS)
  PRODUCTION_API_URL: process.env.REACT_APP_API_URL || 'https://app.darkmattersolutions.ai',
  
  // OCI API URL (IP-based fallback - HTTP for now, HTTPS when port 443 is accessible)
  OCI_API_URL: 'http://129.146.2.109',
  
  // Development API URL (for local development)
  DEVELOPMENT_API_URL: 'http://localhost:5000',
  
  // Current environment
  ENVIRONMENT: process.env.NODE_ENV || 'development',
  
  // Get the appropriate API URL based on environment
  getApiUrl: function() {
    // Always use the production domain URL when on the app subdomain
    if (typeof window !== 'undefined' && 
        (window.location.hostname === 'app.darkmattersolutions.ai' || 
         window.location.hostname === 'darkmattersolutions.ai' || 
         window.location.hostname === 'www.darkmattersolutions.ai')) {
      return this.PRODUCTION_API_URL;
    }
    if (this.ENVIRONMENT === 'production') {
      return this.PRODUCTION_API_URL;
    }
    return this.DEVELOPMENT_API_URL;
  },
  
  // API endpoints
  ENDPOINTS: {
    AUTH: {
      REGISTER: '/auth/register',
      LOGIN: '/auth/login',
      VALIDATE: '/auth/validate',
      API_KEYS: '/auth/api-keys',
      RATE_LIMITS: '/auth/rate-limits',
      HEALTH: '/auth/health'
    },
    AI_BACKGROUND: {
      SOURCES: '/ai-background/sources',
      TEST_CHECK: '/ai-background/test/background-check',
      START_MONITORING: '/ai-background/monitoring/start',
      STOP_MONITORING: '/ai-background/monitoring/stop',
      MONITORING_STATUS: '/ai-background/monitoring/status',
      RED_FLAG_ALERTS: '/ai-background/alerts/red-flags',
      CHANGE_ALERTS: '/ai-background/alerts/changes',
      ANALYTICS: '/ai-background/analytics'
    },
    ATF_COMPLIANCE: {
      VALIDATE: '/atf-compliance/validate'
    },
    DOCUMENTATION: {
      API_DOCS: '/docs/api-docs',
      TEST_SUITE: '/docs/test-suite',
      QUICK_START: '/docs/quick-start'
    }
  },
  
  // Default headers
  DEFAULT_HEADERS: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  },
  
  // Authentication headers (will be set dynamically)
  getAuthHeaders: function(apiKey = null, jwtToken = null) {
    const headers = { ...this.DEFAULT_HEADERS };
    
    if (apiKey) {
      headers['X-API-Key'] = apiKey;
    }
    
    if (jwtToken) {
      headers['Authorization'] = `Bearer ${jwtToken}`;
    }
    
    return headers;
  }
};

export default API_CONFIG;
